import React, { ReactNode } from 'react'
import { routes } from '../../router'
import { matchRoutes, renderRoutes } from "react-router-config";
import { IRouteMeta } from '../../permitRoutes';
import { AuthContext } from '../AuthContext'
import { userService } from '../UserService'
import PageLayout from './PageLayout'
import AdminLayout from './AdminLayout'
import { Login } from '../Login'
import { useHistory } from 'react-router-dom';
import CenterLayout from './CenterLayout';
import UpdateSiteDialog from '../../components/UpdateSiteDialog';

interface Props {
  route?: IRouteMeta
  layout?: string
}

interface State {}

class DefaultLayout extends React.Component<Props, State> {
  static contextType = AuthContext

  get authenticated() {
    return this.context.authenticated
  }

  render(): ReactNode {
    return (
      <>
        {
          (this.props.layout === 'none' && <>{this.props.children}</>) ||
          (this.authenticated && (
              !this.props.layout || (this.props.layout === 'both' || this.props.layout === 'admin') &&
              <AdminLayout route={this.props.route}>{this.props.children}</AdminLayout>
            ) ||
            (
              <PageLayout route={this.props.route}>
              {this.props.children}
              {
                !this.authenticated && (
                  <div style={{display: this.props.route?.requiresAuth ? 'block' : 'none'}}>
                    <Login />
                  </div>
                )
              }
              </PageLayout>
            )
          )
          || (
            <>
              {this.props.children}
            </>
          )
        }
        <UpdateSiteDialog />
      </>
    )
  }
}

export default DefaultLayout
